import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { FeaturesBroadcastBroadcastForm } from '@/features/broadcast';

export const WidgetsBroadcastMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('broadcast.title')} subtitle={t('broadcast.subtitle')} />
      <div className="mx-auto w-full max-w-3xl space-y-4 px-4 py-4 lg:px-6 lg:py-6">
        <FeaturesBroadcastBroadcastForm />
      </div>
    </>
  );
};
